const SERVICES = [
  {
    num: "01",
    title: "Residential Junk",
    desc: "Basements, attics, garages, spare bedrooms, and patio clutter. We sweep clean when the pile is gone.",
    items: ["Mattresses, sofas & dressers", "Boxes, storage bins & clothes", "Workout equipment & bicycles"],
  },
  {
    num: "02",
    title: "Commercial & Office",
    desc: "Property manager tenant turnovers, retail fixture removals, office cubicles, warehouse overflow, and desks.",
    items: ["Office desks, chairs & files", "Apartment turnover trashouts", "Retail display deconstruction"],
  },
  {
    num: "03",
    title: "Furniture & Appliances",
    desc: "Heavy sectionals, broken refrigerators, washers, dryers, water heaters, and solid wood dining sets.",
    items: ["Refrigerators, ovens, dryers", "Sectional sofas, recliners", "Entertainment centers & armoires"],
  },
  {
    num: "04",
    title: "Yard Debris & Branches",
    desc: "Florida storm cleanup, downed palm fronds, felled tree branches, fencing, old deck boards, and landscaping waste.",
    items: ["Storm debris & palm fronds", "Fencing materials & old sheds", "Pavers, gravel & sod scraps"],
  },
  {
    num: "05",
    title: "Estate & Whole Cleanouts",
    desc: "Full-property cleanouts for realtors, probate estates, foreclosures, and hoarder situations with zero judgment.",
    items: ["Entire homes & storage units", "Fast turnaround for closing day", "Donatable goods separated"],
  },
];

export default function Services() {
  return (
    <section id="services" data-testid="services-section" className="py-24 px-4 sm:px-6 lg:px-8 max-w-7xl mx-auto">
      <div className="flex flex-col md:flex-row md:items-end justify-between mb-16 gap-6 border-b border-white/10 pb-8">
        <div>
          <h2 className="text-3xl sm:text-5xl font-black uppercase tracking-tighter font-display text-white">
            What We Clear Away
          </h2>
          <p className="text-zinc-400 text-sm sm:text-base mt-2 max-w-xl">
            From single heavy appliances to entire multi-unit commercial turnovers, our local crew handles every pound.
          </p>
        </div>
        <span className="text-xs font-mono text-zinc-400 uppercase tracking-widest">Full-Service Brevard Hauling</span>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {SERVICES.map((s) => (
          <div
            key={s.num}
            data-testid={`service-card-${s.num}`}
            className="h-full bg-zinc-950 border border-zinc-800 rounded-2xl p-8 flex flex-col justify-between hover:border-white/40 transition-colors"
          >
            <div>
              <div className="text-xs font-mono text-zinc-300 uppercase tracking-wider mb-4">Service #{s.num}</div>
              <h3 className="text-2xl font-black uppercase tracking-tight text-white mb-3">{s.title}</h3>
              <p className="text-sm text-zinc-400 leading-relaxed mb-6">{s.desc}</p>
            </div>
            <ul className="text-xs font-mono text-zinc-400 space-y-2 border-t border-zinc-900 pt-4">
              {s.items.map((item) => (
                <li key={item}>• {item}</li>
              ))}
            </ul>
          </div>
        ))}

        <div className="h-full bg-gradient-to-br from-zinc-900 to-black border border-white/20 rounded-2xl p-8 flex flex-col justify-between text-white">
          <div>
            <span className="inline-block px-2.5 py-1 rounded bg-white text-black font-mono text-[10px] uppercase font-bold tracking-wider mb-4">
              Urgent Dispatch
            </span>
            <h3 className="text-2xl font-black uppercase tracking-tight font-display mb-3">Need It Gone In 24 Hours?</h3>
            <p className="text-sm text-zinc-300 leading-relaxed mb-6">
              We hold daily capacity open for same-day emergency calls throughout Palm Bay, Melbourne, and Brevard.
            </p>
          </div>
          <a
            href="tel:3214202707"
            data-testid="urgent-dispatch-btn"
            className="inline-flex items-center justify-center w-full py-3.5 px-4 rounded-xl bg-white text-black font-bold uppercase text-xs tracking-wider hover:bg-zinc-200 transition-colors"
          >
            Call Dispatch: (321) 420-2707
          </a>
        </div>
      </div>
    </section>
  );
}
